import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, checked, disabled, className, ...rest },
  ref
) {
  return (
    <label
      className={cn(
        'phx-check-label gap-phx-3 text-phx-md inline-flex items-center select-none',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
      data-disabled={disabled ? '' : undefined}
    >
      <span className="phx-radio relative inline-flex">
        <input
          ref={ref}
          type="radio"
          checked={checked}
          disabled={disabled}
          className="peer absolute inset-0 h-full w-full cursor-[inherit] opacity-0"
          {...rest}
        />
        <span
          className={cn(
            'phx-radio-box relative inline-flex h-[15px] w-[15px] items-center justify-center rounded-full',
            'bg-phx-surface peer-focus-visible:shadow-phx-focus border transition-[border-color]',
            checked ? 'border-phx-primary' : 'border-phx-border-3'
          )}
        >
          {checked ? <span className="bg-phx-primary absolute inset-[3px] rounded-full" /> : null}
        </span>
      </span>
      {label ? <span>{label}</span> : null}
    </label>
  );
});
